import { FC, useState } from 'react';
import { IlogisticServiceDetails } from '../../../../../../types/services';
import PaymentMethodComponent from './Components/PaymentMethodComponent/PaymentMethodComponent';
import { DocumentsComponent } from './Components/DocumentsComponent';
import './LogisticServicePaymentDetail.scss';

const LogisticServicePaymentDetail: FC<ILogisticServicePaymentDetail> = ({
  logisticServiceData,
  updateWithLoaders,
  updateWithoutLoader
}: ILogisticServicePaymentDetail) => {

  return (
    <div id="logisticServicePaymentDetail">
      <PaymentMethodComponent
        logisticServiceData={logisticServiceData}
        updateWithLoaders={updateWithLoaders}
        updateWithoutLoader={updateWithoutLoader}
      />
      <DocumentsComponent
        logisticServiceData={logisticServiceData}
        updateWithLoaders={updateWithLoaders}
      />
    </div>
  );
};

export default LogisticServicePaymentDetail;

interface ILogisticServicePaymentDetail {
  logisticServiceData: IlogisticServiceDetails;
  updateWithLoaders: () => Promise<void>;
  updateWithoutLoader: () => Promise<void>;
}
